export const FETCH_CATALOG_APP = 'space/app/catalog/FETCH'
export const FETCH_CATALOG_APP_SUCCESS = `${FETCH_CATALOG_APP}_SUCCESS`

export const CLEAR_CURRENT_CATALOG_APP = 'CLEAR_CURRENT_CATALOG_APP'

export const UPDATE_CATALOG_APP_INSTANCE = 'space/app/catalog/instance/UPDATE'
export const UPDATE_CATALOG_APP_INSTANCE_SUCCESS = `${UPDATE_CATALOG_APP_INSTANCE}_SUCCESS`

export const ADD_CATALOG_APP_INSTANCE = 'space/app/catalog/instance/ADD'
export const ADD_CATALOG_APP_INSTANCE_SUCCESS = `${ADD_CATALOG_APP_INSTANCE}_SUCCESS`

export const DELETE_CATALOG_APP_INSTANCE = 'space/app/catalog/instance/DELETE'
export const DELETE_CATALOG_APP_INSTANCE_SUCCESS = `${DELETE_CATALOG_APP_INSTANCE}_SUCCESS`

export const FETCH_CATALOG_APP_INSTANCE = 'space/app/catalog/instance/GET'
export const FETCH_CATALOG_APP_INSTANCE_SUCCESS = `${FETCH_CATALOG_APP_INSTANCE}_SUCCESS`

export const CLEAR_CURRENT_APP_INSTANCE = 'CLEAR_CURRENT_APP_INSTANCE'
